import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface KeyboardState {
  isOpen: boolean;
  activeTargetId?: string;
  type?: 'text' | 'number-format';
}

const initialState: KeyboardState = {
  isOpen: false,
};

export const KeyboardSlice = createSlice({
  name: 'keyboard',
  initialState,
  reducers: {
    openKeyboard(
      state,
      action: PayloadAction<{ id: string; type: 'text' | 'number-format' }>,
    ) {
      state.activeTargetId = action.payload.id;
      state.type = action.payload.type;
      state.isOpen = true;
    },
    closeKeyboard(state) {
      state.isOpen = false;
      state.activeTargetId = undefined;
      state.type = undefined;
    },
  },
});

export const { openKeyboard, closeKeyboard } = KeyboardSlice.actions;
export default KeyboardSlice.reducer;
